module.exports = __webpack_public_path__ + "img/t-1.8af469a.png";